<template>
  <d-container fluid class="main-content-container px-4 pb-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <!-- Page Title -->
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('editor.title') }}</span>
        <h3 class="page-title">{{ $t('editor.sub') }}</h3>
      </d-col>
    </d-row>

    <d-row>
      <!-- Editor -->
      <d-col lg="9" md="12" class="my-2">
        <anp-editor
          :sendModalToggle="toggleEmailModal"
          :handleSend="handleSendEmail"
          :content="templateContent"
        />
      </d-col>

      <!-- Sidebar Widgets -->

      <d-col lg="3" md="12">
        <anp-sidebar-templates class="my-2" />
        <anp-sidebar-inputs class="my-2" />
        <anp-sidebar-links class="my-2" />
      </d-col>

      <!-- Sidebar Dynamic Links -->

      <!-- Connect Email Modal -->
      <d-modal v-if="showEmailModal" @close="handleCloseEmail">
        <d-modal-header>
          <d-modal-title>{{ $t('editor.accounts') }}</d-modal-title>
        </d-modal-header>
        <d-modal-body class="pt-2">
          <p>{{ $t('editor.accountssub') }}</p>
          <h5>Existing Accounts</h5>
          <div style="display:flex; flex-direction: row;">
            <div v-for="profile in getCurrentUser.profiles" :key="profile._id">
              <img
                :id="`avatar-${profile._id}`"
                @click="sendEmailWithProfile(profile)"
                src="@/assets/images/avatars/avatar.svg"
                alt="User Avatar"
                class="user-avatar rounded-circle mr-2 icon-account use-existing"
              />
              <d-tooltip :target="`avatar-${profile._id}`">{{profile.email}}</d-tooltip>
            </div>
          </div>
          <h5 class="mb-4 mt-4">{{ $t('editor.connectnew') }}</h5>
          <gmail-oauth-button
            class="connect-wrapper"
            state="foobar"
            :onSuccess="handleSuccessOauth"
          ></gmail-oauth-button>
          <!--
          <other-oauth-button
            class="connect-wrapper ml-3"
            redirectUri="http://localhost:8080/linkedin"
            clientId="81mc14l4xar16a"
            :scope="['r_liteprofile', 'w_member_social', 'r_emailaddress']"
            state="foobar"
            :onSuccess="handleSuccessOauth"
          ></other-oauth-button>
          -->
        </d-modal-body>
      </d-modal>
      <!-- / Connect Accounts Modal -->

      <!-- Connect Social Accounts Modal -->
      <d-modal v-if="showConnectModal" @close="handleCloseSocial">
        <d-modal-header>
          <d-modal-title>{{ $t('editor.social') }}</d-modal-title>
        </d-modal-header>
        <d-modal-body class="pt-2">
          <p>{{ $t('editor.socialsub') }}Choose a social account to send messages from</p>
          <h5>{{ $t('editor.sub') }}Existing accounts</h5>
          <!-- Existing Account Profile Button -->
          <existing-account />
          <h5 class="mb-4 mt-4">{{ $t('editor.socialconnect') }}</h5>
          <linkedin-oauth-button
            class="connect-wrapper"
            redirectUri="http://localhost:8080/linkedin"
            clientId="81mc14l4xar16a"
            :scope="['r_liteprofile', 'w_member_social', 'r_emailaddress']"
            state="foobar"
            :onSuccess="handleSuccessOauth"
          ></linkedin-oauth-button>
        </d-modal-body>
      </d-modal>
      <!-- / Connect Social Accounts Modal -->
    </d-row>
  </d-container>
</template>

<script>
import {
  AUTH_AUTHENTICATE_GOOGLE,
  CAMPAIGN_SEND_CONTACT,
  TEMPLATE_GET_LIST,
  CAMPAIGN_GET
} from "@/store/types";

import SidebarInputs from "@/components/TemplateEditor/SidebarInputs.vue";
import SidebarLinks from "@/components/TemplateEditor/SidebarLinks.vue";
import SidebarTemplates from "@/components/TemplateEditor/SidebarTemplates.vue";
import Editor from "@/components/TemplateEditor/Editor.vue";
import LinkedInOauthButton from "@/components/common/Linkedin/LinkedInOauthButton.vue";
import GmailOauthButton from "@/components/common/Gmail/GmailOauthButton.vue";
import OtherOauthButton from "@/components/common/Other/OtherOauthButton.vue";
import ExistingAccount from "@/components/common/ExistingAccount.vue";

import "quill/dist/quill.snow.css";

import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters([
      "getCurrentUser",
      "getCurrentTemplate",
      "getCurrentCampaign"
    ])
  },
  mounted() {
    this.$store.dispatch(TEMPLATE_GET_LIST);

    if (!this.getCurrentCampaign) {
      this.$store.dispatch(CAMPAIGN_GET, this.$route.params.id);
    }
  },
  components: {
    anpEditor: Editor,
    anpSidebarInputs: SidebarInputs,
    anpSidebarLinks: SidebarLinks,
    anpSidebarTemplates: SidebarTemplates,
    linkedinOauthButton: LinkedInOauthButton,
    GmailOauthButton: GmailOauthButton,
    OtherOauthButton: OtherOauthButton,
    ExistingAccount: ExistingAccount
  },
  data() {
    return {
      showConnectModal: false,
      name: "modal-connect",
      showEmailModal: false,
      name: "modal-email",
      emailData: {},
      templateContent: ""
    };
  },
  methods: {
    handleClickSocial() {
      this.showConnectModal = true;
    },
    handleCloseSocial() {
      this.showConnectModal = false;
    },
    handleClickEmail() {
      this.showEmailModal = true;
    },
    handleCloseEmail() {
      this.showEmailModal = false;
    },
    toggleEmailModal() {
      this.showEmailModal = !this.showEmailModal;
    },
    async handleSuccessOauth(data) {
      try {
        const response = await this.$store.dispatch(AUTH_AUTHENTICATE_GOOGLE, {
          code: data.code
        });
        await this.sendEmailWithProfile(response.data); //profile_id
        this.$router.push({
          name: "campaign-prospects",
          params: { id: this.getCurrentCampaign._id }
        });
      } catch (err) {
        console.log(err);
      }
    },
    handleSendEmail(emailData) {
      this.emailData = emailData;
    },
    async sendEmailWithProfile(profile) {
      try {
        await this.$store.dispatch(CAMPAIGN_SEND_CONTACT, {
          ...this.emailData,
          type: "gmail",
          profile_id: profile._id,
          template_id: this.getCurrentTemplate
            ? this.getCurrentTemplate._id
            : null
        });
        this.$router.push({
          name: "campaign-prospects",
          params: { id: this.getCurrentCampaign._id }
        });
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>
